export const types = {
  SET_KEYWORDS: "SET_KEYWORDS",
  SAVE_KEYWORD: "SAVE_KEYWORD",
  DELETE_KEYWORD: "DELETE_KEYWORD",

  SET_TAGS: "SET_TAGS",
  SAVE_TAG: "SAVE_TAG",
  DELETE_TAG: "DELETE_TAG",
};
